<template>
  <section class="s-services">
    <div class="services-row" v-for="item in data.items" :key="item.h4" data-cta :style="{ 'pointer-events': item.t.length > 0 ? 'auto' : 'none' }">
      <div class="services-mask">
        <h4>{{ item.h4 }}</h4>
        <svg viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="item.t.length > 0">
          <path d="M20.648 10.147L10.501 20.294L0.353994 10.147" stroke="#383838" stroke-miterlimit="10" />
        </svg>
        <p>{{ item.p }}</p>
        <p>{{ item.t }}</p>
      </div>
    </div>
  </section>
</template>

<script>
import { app } from '@/utils/store';
import Services from './services';
import nodata from './data';

let services;

const data = nodata[app.language];

export default {
  data() {
    return {
      data,
    };
  },
  mounted() {
    services = new Services();
    services.init();
  },
};
</script>
